import { Field, FieldError, FieldLabel } from "@/client/components/shad/field";
import { Input } from "@/client/components/shad/input";
import { useFieldContext } from "../form-context";
import {
  NativeSelect,
  NativeSelectOption,
} from "@/client/components/shad/native-select";

type Props = {
  fieldLabel: string;
  list: {
    label: string;
    value: string;
  }[];
};

export function SelectField(props: Props) {
  const field = useFieldContext<string>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;
  return (
    <Field>
      <FieldLabel>{props.fieldLabel}</FieldLabel>
      <NativeSelect
        name={field.name}
        value={field.state.value}
        onChange={(e) => field.handleChange(e.target.value)}
      >
        {props.list.map((item) => {
          return (
            <NativeSelectOption
              key={`${field.name}-${item.value}`}
              value={item.value}
            >
              {item.label}
            </NativeSelectOption>
          );
        })}
      </NativeSelect>
      {isInvalid && (
        <FieldError className="text-xs" errors={field.state.meta.errors} />
      )}
    </Field>
  );
}
